<div class="add-exam-container">
    <div class="add-exam-search">
        <form (keyup.enter)="onSearch()" class="add-exam-form">
            <mat-form-field>
                <input [(ngModel)]="examToSearch.surname" name="surname" matInput [placeholder]="'LastName' | translate">
            </mat-form-field>
            <mat-form-field>
                <input [(ngModel)]="examToSearch.name" name="name" matInput [placeholder]="'FirstName' | translate">
            </mat-form-field>

            <mat-form-field>
                <input [(ngModel)]="examToSearch.date" name="date" matInput [placeholder]="'ExamDate' | translate" [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <button matSuffix mat-icon-button type="button" (click)="onResetDate()" tabIndex="-1">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <button mat-button [class.add-exam-part-disabled]="loading" class="add-exam-search"
                    (click)="onSearch()">
                <mat-icon *ngIf="!loading">search</mat-icon>
                <mat-icon *ngIf="loading">hourglass_empty</mat-icon>
            </button>
        </form>
    </div>
    <div class="grid-container">
        <ag-grid-angular #datagrid class="worklist-grid ag-theme-material" [gridOptions]="gridOptions" [rowData]="items" (selectionChanged)="onSelectionChange($event)">
        </ag-grid-angular>
    </div>

    <div class="add-exam-message">
        <label>{{message}}</label>
    </div>

    <div class="add-exam-buttons">
        <button mat-button [class.add-exam-part-disabled]="!canAdd()" (click)="onAdd()">
            <p translate>AddExam</p>
        </button>
        <button mat-button (click)="onClose(false)">
            <p translate>Cancel</p>
        </button>
    </div>

</div>
